import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'src/registry/ui/Checkbox';
import { FormControl, FormControlStack, FormField, FormItem, FormLabel } from 'src/registry/ui/Form';
import { MembershipTypeFormSchemaValues } from 'src/features/membershipType/formSchema';

const CheckboxFormField = ({
    form,
    fieldName,
    title,
    disabled = false,
}: {
    form: UseFormReturn<MembershipTypeFormSchemaValues>;
    fieldName: keyof MembershipTypeFormSchemaValues;
    title: { id: string; defaultMessage: string };
    disabled?: boolean;
}) => {
    return (
        <FormField
            control={form.control}
            name={fieldName}
            render={({ field }) => (
                <FormItem variant="dialog">
                    <FormLabel variant="dialog">
                        <FormattedMessage {...title} />
                    </FormLabel>
                    <FormControlStack>
                        <FormControl>
                            <Checkbox
                                disabled={disabled}
                                checked={!!field.value}
                                onCheckedChange={(checked) => {
                                    const value = checked === true;
                                    field.onChange(value);
                                }}
                            />
                        </FormControl>
                    </FormControlStack>
                </FormItem>
            )}
        />
    );
};

export default CheckboxFormField;
